<template>
    <div class="workReport">
        <template v-if="!ifAdd">
            <div id="bar" style="margin-bottom:10px">
                <label>选择周数：</label>
                <Input type="text" style="width:200px"></Input>
                <Button type="primary" style="margin-left:10px">搜索</Button>
                <Button type="primary" style="margin-left:10px" @click="ifAdd=true">新增</Button>
            </div>
        </template>
        <wrt-table v-show="!ifAdd"></wrt-table>
        <add-table v-if="ifAdd" ref="addTable"></add-table>
        <template v-if="ifAdd">
            <div id="footbar" style="margin-top:20px;text-align:right">
                <Button type="text" style="margin-left:10px" @click="cancel">取消</Button>
                <Button type="primary" @click="commit">提交</Button>
            </div>
        </template>
    </div>
</template>

<script>
    import wrtTable from "./table.vue"
    import addTable from "./add-table.vue"

    export default {
        components: {
            wrtTable,
            addTable
        },
        data() {
            return {
                ifModal: false,
                ifAdd: false
            }
        },
        methods: {
            commit(){
                this.$refs.addTable.commit();
                this.ifAdd=false;
            },
            cancel(){
                // this.$refs.addTable.cancel();
                this.ifAdd=false;
            }
        }
    }
</script>